import React from 'react';
import clsx from 'clsx';

import { Img } from './wrappers';
import { CSSProperties } from 'styled-components';

export interface IImage {
  alt?: string;
  title?: string;
  className?: string;
  height?: string;
  imageLoading?: 'lazy' | 'eager';
  onLoad?: () => void;
  sizes?: string;
  src: string;
  srcSet?: string;
  style?: CSSProperties;
  width?: string;
  widthAuto?: boolean; // Replaces 100% width image source width
}

export const Image = ({
  alt,
  title,
  className,
  height,
  imageLoading = 'lazy',
  onLoad,
  sizes,
  src,
  srcSet,
  style,
  width,
  widthAuto,
}: IImage) => {
  const imgRef = React.useRef<HTMLImageElement>(null);

  React.useEffect(() => {
    if (imgRef.current?.complete) {
      onLoad && onLoad();
    }
  }, [imgRef.current?.complete]);

  return (
    <Img
      ref={imgRef}
      alt={alt}
      title={title}
      className={clsx(className, widthAuto && 'width-auto')}
      height={height}
      loading={imageLoading}
      onLoad={onLoad}
      sizes={sizes}
      src={src}
      srcSet={srcSet}
      style={style}
      width={width}
    />
  );
};

export interface ISource {
  srcSet: string;
  sizes?: string;
  media?: string;
  type?: string;
}

export interface IPicture {
  image: IImage;
  imageLoading?: 'lazy' | 'eager';
  imageStyle?: CSSProperties;
  onLoad?: () => void;
  sources?: ISource[];
}

export const Picture = ({ sources, image, imageStyle, imageLoading, onLoad }: IPicture) => (
  <picture>
    {sources?.map((source, index) => (
      <source
        key={`${source.srcSet}-${index}`}
        type={source.type}
        srcSet={source.srcSet}
        sizes={source.sizes}
        media={source.media}
      />
    ))}
    <Image
      alt={image.alt}
      height={image.height}
      imageLoading={imageLoading}
      onLoad={onLoad}
      sizes={image.sizes}
      src={image.src}
      srcSet={image.srcSet}
      style={imageStyle}
      width={image.width}
      widthAuto={image.widthAuto}
    />
  </picture>
);
